import { Input, InputProps } from "@nextui-org/react";
import React from "react";
import styles from "./index.module.css";
import { cn } from "@/lib/utils";
type InputFieldProps = {
  inputProps: {} & InputProps;
};
function InputField({
  inputProps
}: InputFieldProps) {
  const {
    classNames,
    variant,
    ...rest
  } = inputProps;
  return <div className="flex flex-col gap-1" data-sentry-component="InputField" data-sentry-source-file="index.tsx">
      <Input classNames={{
      ...classNames,
      inputWrapper: cn(classNames?.inputWrapper, variant == "bordered" && `group-data-[focus=true]:border-white ${styles?.input_wrapper_bordered}`, variant == "flat" && `group-data-[focus=true]:!bg-unset ${styles?.input_wrapper_flat}`),
      input: cn(classNames?.input, variant == "flat" && "group-data-[has-value=true]:text-white")
    }} autoComplete="off" variant={variant} {...rest} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
    </div>;
}
export default InputField;